const helpers = {
    cutText(text, length) {
        if (text.split(" ").length > 1) {
            let string = text.substring(0, length);
            let splitText = string.split(" ");
            splitText.pop();
            return splitText.join(" ") + "...";
        } else {
            return text;
        }
    },
    formatDate(date, format) {
        return date;
    },
    capitalizeFirstLetter(string) {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    onlyNumber(number) {
        if (number) {
            return number.replace(/\D/g, "");
        } else {
            return "";
        }
    },
    formatCurrency(number) {
        if (number) {
            let formattedNumber = number.toString().replace(/\D/g, "");
            let rest = formattedNumber.length % 3;
            let currency = formattedNumber.substr(0, rest);
            let thousand = formattedNumber.substr(rest).match(/\d{3}/g);
            let separator;

            if (thousand) {
                separator = rest ? "." : "";
                currency += separator + thousand.join(".");
            }

            return currency;
        } else {
            return "";
        }
    },
    isset(obj) {
        return Object.keys(obj).length;
    },
    assign(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    delay(time) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    },
    randomNumbers(from, to, length) {
        let numbers = [0];
        for (let i = 1; i < length; i++) {
            numbers.push(Math.ceil(Math.random() * (from - to) + to));
        }

        return numbers;
    },
    replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, "g"), replace);
    },
    subDate(first, second, type){
        if(type == 'current'){
            // first = new Date();
            first = (new Date().getFullYear())+'-'+((new Date().getMonth() + 1) < 10 ? ('0'+ (new Date().getMonth() + 1)) : (new Date().getMonth() + 1))+'-'+(new Date().getDate())
        }
        if(first && second){
            const date1 = new Date(first);
            const date2 = new Date(second);
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            // console.log(diffTime + " milliseconds");
            if(diffDays != undefined){
                return diffDays;
            }else{
                return 0;
            }
        }
        else{
            return 0;
        }
    },
    calculateCommission(data, user_id, type){
        let project_type = import.meta.env.VITE_PROJECT_TYPE;
        let seller_commision_per = 0;
        let seller_commision = 0;
        let co_seller_commision_per = 0;
        let co_seller_commision = 0;
        let newseller_commision = 0;
        const effectiveSoldDate = data.sold_date < '2026-07-01' ? data.sold_funded_date : data.sold_date;
        let days_on_site = effectiveSoldDate != '' && effectiveSoldDate != null && data.export_status_date != '' && data.export_status_date != null ? this.subDate(data.export_status_date, effectiveSoldDate) : '';

        if (data?.seller_id != '' && data?.co_seller_id != '' && data?.seller_id != null && data?.co_seller_id != null) {
            if (data?.seller_id == data?.co_seller_id) {
                seller_commision_per = data?.seller?.commission ? data?.seller?.commission?.commission_seller / 2 : 0;

                seller_commision = +(data?.actual_profit / 100) * +seller_commision_per;
                if(data?.top_order_sold == '1'){
                    if (project_type == 'dninv') {
                        seller_commision = 250;
                    }
                    else{
                        seller_commision = 200;
                    }
                }
                else{
                    if (project_type == 'dninv') {
                        let com_val = 100;
                        if(days_on_site >= 120){
                            com_val = 150;
                        }
                        if (seller_commision < com_val) {
                            newseller_commision =  com_val - +seller_commision;
                            seller_commision = +newseller_commision + +seller_commision;
                        }
                    }
                    else{
                        if (seller_commision < 100) {
                            newseller_commision =  100 - +seller_commision;
                            seller_commision = +newseller_commision + +seller_commision;
                        }
                    }
                }
                if(data?.seller?.zero_commission == '1'){
                    seller_commision = 0;
                }

                if (project_type == 'dninv') {
                    if(data?.top_order_sold == '1'){
                        if(seller_commision > 250){
                            seller_commision = 250;
                        }
                    }
                    else{
                        if(seller_commision > 200){
                            seller_commision = 200;
                        }
                    }
                }
                else{
                    if(seller_commision > 200){
                        seller_commision = 200;
                    }
                }


                if(type == 'seller'){
                    return seller_commision;
                }
                else if(type == 'co-seller'){
                    return seller_commision;
                }
                return seller_commision * 2;
            } else {
                seller_commision_per = data?.seller?.commission ? data?.seller?.commission?.commission_seller : 0;
                // co_seller_commision_per = data?.co_seller?.commission?.commission_coseller;
                co_seller_commision_per = +seller_commision_per / 2;
                seller_commision_per = +seller_commision_per / 2;

                seller_commision = +(data?.actual_profit / 100) * +seller_commision_per;
                co_seller_commision = +(data?.actual_profit / 100) * +co_seller_commision_per;

                if(data?.top_order_sold == '1'){
                    if(project_type == 'dninv'){
                        seller_commision = 250;
                        co_seller_commision = 250;
                    }
                    else{
                        seller_commision = 200;
                        co_seller_commision = 200;
                    }
                }
                else{
                    if (project_type == 'dninv') {
                        let com_val = 100;
                        if(days_on_site >= 120){
                            com_val = 150;
                        }

                        if (seller_commision < com_val) {
                            newseller_commision =  com_val - +seller_commision;
                            seller_commision = +newseller_commision + +seller_commision;
                        }
                        if (co_seller_commision < com_val) {
                            newseller_commision =  com_val - +co_seller_commision;
                            co_seller_commision = +newseller_commision + +co_seller_commision;
                        }
                    }
                    else{
                        if (seller_commision < 100) {
                            newseller_commision =  100 - +seller_commision;
                            seller_commision = +newseller_commision + +seller_commision;
                        }
                        if (co_seller_commision < 100) {
                            newseller_commision =  100 - +co_seller_commision;
                            co_seller_commision = +newseller_commision + +co_seller_commision;
                        }
                    }
                }

                if(data?.seller?.zero_commission == '1'){
                    seller_commision = 0;
                }

                if(data?.co_seller?.zero_commission == '1'){
                    co_seller_commision = 0;
                }

                if (project_type == 'dninv') {
                    if(data?.top_order_sold == '1'){
                        if(seller_commision > 250){
                            seller_commision = 250;
                        }
                        if(co_seller_commision > 250){
                            co_seller_commision = 250;
                        }
                    }
                    else{
                        if(seller_commision > 200){
                            seller_commision = 200;
                        }
                        if(co_seller_commision > 200){
                            co_seller_commision = 200;
                        }
                    }
                }
                else{
                    if(seller_commision > 200){
                        seller_commision = 200;
                    }
                    if(co_seller_commision > 200){
                        co_seller_commision = 200;
                    }
                }

                if(type == 'seller' && user_id != null){
                    return data?.seller_id == user_id ? seller_commision : '';
                }
                else if(type == 'co-seller' && user_id != null){
                    return data?.co_seller_id == user_id ? co_seller_commision : '';
                }

                if(type == 'seller'){
                    return seller_commision;
                }
                else if(type == 'co-seller'){
                    return co_seller_commision;
                }

                if(data?.seller_id == user_id && (type == null || type == '')){
                    return seller_commision;
                }
                else if(data?.co_seller_id == user_id && (type == null || type == '')){
                    return co_seller_commision;
                }
                
                return +seller_commision + +co_seller_commision;
            }
        }
        if ((data.seller_id != '' && data.seller_id != null) && (data.co_seller_id == '' || data.co_seller_id == null)) {
            seller_commision_per = data?.seller?.commission ? data?.seller?.commission?.commission_seller : 0;
            
            seller_commision = +(data?.actual_profit / 100) * +seller_commision_per;

            if(data?.top_order_sold == '1'){
                if(project_type == 'dninv'){
                    seller_commision = 500;
                }
                else{
                    seller_commision = 400;
                }
            }else{
                if (project_type == 'dninv') {
                    let com_val = 100;
                    if(days_on_site >= 120){
                        com_val = 150;
                    }
                    if (seller_commision < com_val) {
                        newseller_commision =  com_val - +seller_commision;
                        seller_commision = +newseller_commision + +seller_commision;
                    }
                }
                else{
                    if (seller_commision < 200) {
                        newseller_commision =  200 - +seller_commision;
                        seller_commision = +newseller_commision + +seller_commision;
                    }
                }
            }

            if(data?.seller?.zero_commission == '1'){
                seller_commision = 0;
            }

            if (project_type == 'dninv') {
                if(data?.top_order_sold == '1'){
                    if(seller_commision > 500){
                        seller_commision = 500;
                    }
                }
                else{
                    if(seller_commision > 400){
                        seller_commision = 400;
                    }
                }
            }
            else{
                if(seller_commision > 400){
                    seller_commision = 400;
                }
            }


            if(type == 'seller' && user_id != null){
                return data?.seller_id == user_id ? seller_commision : '';
            }
            else if(type == 'co-seller' && user_id != null){
                return 0;
            }

            if(type == 'seller'){
                return seller_commision;
            }
            else if(type == 'co-seller'){
                return 0;
            }

            if(data?.seller_id == user_id && (type == null || type == '')){
                return seller_commision;
            }
            // else if(data?.co_seller_id == user_id && (type == null || type == '')){
            //     return 0;
            // }
            return seller_commision;
        }
        return 0;
    },
};

export default helpers;
